import { AccommodationBookingObjectDto } from '@shared/integrations/umbraco-taf-delivery-api/models';

interface ICabinObjectListItemMetaData {
    item: AccommodationBookingObjectDto;
}
const CabinObjectListItemMetaData = ({ item }: ICabinObjectListItemMetaData) => {
    const calcGuests = () => {
        let beds = 0;
        if (item.metaData?.numberOfDoubleBeds) beds += item.metaData?.numberOfDoubleBeds * 2;
        if (item.metaData?.numberOfSingleBeds) beds += item.metaData?.numberOfSingleBeds;
        if (item.metaData?.numberOfBunkBeds) beds += item.metaData?.numberOfBunkBeds * 2;
        return beds;
    };

    return (
        <ul className='list-unstyled d-flex flex-wrap column-gap-1 text-muted'>
            <div className='list-bullet'>{calcGuests()} gäster</div>
            <div className='list-bullet'>{item.metaData?.numberOfRooms} sovrum</div>
            <div className='list-bullet'>{item.metaData?.numberOfBathRooms} badrum</div>
        </ul>
    );
};

export default CabinObjectListItemMetaData;
